<template>
    <ob1-popin-modal2 :id="modalId" :aria-labelledby="modalId" @ob1-popin-modal-click="onClosePopin()">
        <h3 class="mb-1 mb-md-2" v-html="labels.title" />
        <div class="row">
            <div class="col-12 col-lg-6">
                <fieldset>
                    <legend class="visually-hidden">
                        Etat du mobile Reconditionné
                    </legend>
                    <ob1-chips
                        v-for="(grade, index) in labels.descriptions"
                        :id="'popin-grade-' + index"
                        :key="'popin-grade-' + index"
                        :is-choice-version="true"
                        :label="grade.label"
                        :disable-uncheck="true"
                        :is-checked="selectedGrade === grade"
                        additional-classes="mb-1"
                        @ob1-chips-click="changeSelectedGrade(grade)"
                    />
                </fieldset>
                <div v-html="selectedGrade.text" />
            </div>
            <a class="visually-hidden" href="#grade-details-info">{{ labels.avoidanceLinkLabel }}</a>
            <div class="col-12 col-lg-6 mt-1 mt-lg-0">
                <ob1-carrousel
                    id="grade-details-carrousel"
                    class="mb-1"
                    :images="selectedGrade.images"
                    :with-zoom="true"
                    @onZoomChange="zoomChangeHandler"
                />
            </div>
        </div>

        <ob1-message-alerte
            id="grade-details-info"
            class="mt-lg-2"
            type="info"
            :is-simple-alerte="false"
            :title="labels.message.title"
            :text="labels.message.description"
            :liste-a-puces-dto="listAPuces"
            role="status"
        />
        <p class="pt-0 small" v-html="labels.legalMentions" />
    </ob1-popin-modal2>
</template>
<script>

export default {
    name: 'GradePopin',
    props: {
        modalId: {
            type: String,
            required: true
        },
        defaultGradeId: {
            type: String,
            required: true
        },
        labels:{
            type: Object,
            required: true
        }
    },
    data() {
        return {
            currentGrade: null,
            tmsCurrentZoom: "zoom_desactive"
        }
    },
    computed: {
        listAPuces() {
            return {'texts': this.labels.message.texts, 'noStyle': false, 'additionalClasses': ''}
        },
        defaultGrade(){
            return this.labels.descriptions.find(grade => grade.id === this.defaultGradeId)
        },
        selectedGrade(){
            if (this.currentGrade) return this.currentGrade;
            else return this.defaultGrade
        }
    },
    methods: {
        onClosePopin(){
            this.currentGrade = null
        },
        changeSelectedGrade(grade){
            this.currentGrade = grade
            this.sendTmsForGradePopin(grade)
        },
        getAction() {
          switch (this.selectedGrade.id) {
            case "good":
              return "voir_etat_correct_" + this.tmsCurrentZoom;
            case "very_good":
              return "voir_tres_bon_etat_" + this.tmsCurrentZoom;
            case "perfect":
              return "voir_parfait_etat_" + this.tmsCurrentZoom;
            case "excellent":
              return "voir_excellent_etat_" + this.tmsCurrentZoom;
          }
        },
        sendTmsForGradePopin() {
          Tms.link({
            category: "comment_choisir_son_reconditionné",
            action: this.getAction(),
            label: "popin_ouverte"
          });
        },
        zoomChangeHandler(zoomScale) {
            if (zoomScale === 3) {
                this.tmsCurrentZoom = "zoom_desactive"
            } else {
                this.tmsCurrentZoom = "zoom_active"
            }
            this.sendTmsForGradePopin()
        }
    }
}
</script>
